import React from 'react';

import differenceInYears from 'date-fns/differenceInYears';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';

import { IconInput } from 'shared/components/molecules/IconInput/IconInput';
import { Button } from 'shared/components/atoms/Button/Button';

import input_person from 'assets/icons/person.svg';
import filled_person from 'assets/icons/filled_person.svg';
import phone from 'assets/icons/phone.svg';
import filled_phone from 'assets/icons/filled_phone.svg';

import { Container } from './_firstRegisterGroup';
import { bornDateFormat, cpfFormat, phoneFormat } from 'utils/format';
import { SanitizedInput } from 'shared/components/molecules/SanitizedInput/SanitizedInput';
import { useHistory } from 'react-router-dom';

interface RegisterProps {
  name: string;
  setName: Function;
  cpf: string;
  setCpf: Function;
  phoneNumber: string;
  setPhoneNumber: Function;
  setCurrentStep: Function;
  bornDate: string;
  setBornDate: Function;
}

function isBornDateInvalid(bornDate: string) {
  const newDate = parse(bornDateFormat(bornDate), 'dd/MM/yyyy', new Date());
  const currentDate = new Date();

  if (!isValid(newDate)) {
    return true;
  }

  if (differenceInYears(currentDate, newDate) < 18) {
    return true;
  }
}

export const FirstRegisterGroup: React.FC<RegisterProps> = ({
  name,
  setName,
  cpf,
  setCpf,
  phoneNumber,
  setPhoneNumber,
  setCurrentStep,
  bornDate,
  setBornDate,
}) => {
  const history = useHistory();

  const disableCondition = () => {
    if (
      name.length < 1 ||
      bornDate.length < 8 ||
      cpf.length < 3 ||
      phoneNumber.length < 10
    ) {
      return true;
    }

    if (isBornDateInvalid(bornDate)) {
      return true;
    }

    return false;
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container className="group-wrapper">
      <IconInput
        icon={input_person}
        activeIcon={filled_person}
        placeholder={'Nome completo'}
        inputValue={name}
        setInputValue={setName}
        maxLength={30}
      />

      <SanitizedInput
        icon={input_person}
        activeIcon={filled_person}
        placeholder={'Data de nascimento'}
        inputValue={bornDateFormat(bornDate)}
        setInputValue={setBornDate}
        maxLength={10}
      />

      <SanitizedInput
        icon={input_person}
        activeIcon={filled_person}
        placeholder={'CPF'}
        inputValue={cpfFormat(cpf)}
        setInputValue={setCpf}
        maxLength={14}
      />

      <SanitizedInput
        icon={phone}
        activeIcon={filled_phone}
        placeholder={'Celular'}
        inputValue={phoneFormat(phoneNumber)}
        setInputValue={setPhoneNumber}
        maxLength={15}
      />

      <Button onClick={() => setCurrentStep(1)} disabled={disableCondition()}>
        Próximo
      </Button>
      <Button backgroundColor="#C42D2D" onClick={handleGoBack}>
        Voltar
      </Button>
    </Container>
  );
};
